var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9271 26.2525C54.152 30.8957 53.8615 35.8087 52.098 40.2752C50.3345 44.7417 47.1903 48.528 43.1238 51.082C39.0573 53.636 34.2812 54.8242 29.492 54.4732C24.7028 54.1222 20.151 52.2505 16.5003 49.1309C12.8496 46.0113 10.2909 41.8071 9.19746 37.1312C8.10399 32.4554 8.53287 27.5525 10.4216 23.1375C12.3103 18.7225 15.56 15.0264 19.6969 12.588C23.8338 10.1496 28.6415 9.0966 33.4189 9.58245",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.7234 31.6742L39.3539 22.0438M39.3539 22.0438L40.6666 13.3771L48.1731 6L49.3333 12.0644L55.3977 13.2245L48.0206 20.731L39.3539 22.0438ZM42.9107 29.0811C43.5187 31.5324 43.3467 34.1124 42.4186 36.4614C41.4906 38.8104 39.8528 40.8113 37.7336 42.1852C35.6143 43.5591 33.1192 44.2376 30.596 44.1261C28.0728 44.0146 25.6473 43.1186 23.6575 41.5631C21.6677 40.0076 20.2128 37.87 19.4956 35.4483C18.7785 33.0266 18.8347 30.4415 19.6566 28.0533C20.4784 25.6652 22.0249 23.5929 24.0805 22.1254C26.1361 20.6579 28.5983 19.8683 31.124 19.8667",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3232 51.0664L17.5898 57.9997",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 51.0664L45.3232 57.9997",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalSvg);
export default __webpack_public_path__ + "static/media/goalSVG.6672cf9939ef65a4eb70409a23ddf11c.svg";
export { ForwardRef as ReactComponent };